import { STORAGE_KEYS } from '@/constants/storage'
import debounce from '@/utils/debounce'
import localStorage from '@/utils/localStorage'

/**
 * This provides helper functions for CRUD operations related to user content inside client storage
 */
class AutoSaveManager {
  constructor(scope) {
    this.scope = scope
  }

  getSavedContent = key => {
    const userContent = localStorage.getItem(STORAGE_KEYS.userContent, 'json')
    const savedContent = userContent?.[this.scope]?.[key]
    if (savedContent) {
      return savedContent.content
    }
  }

  saveContent = debounce((key, data) => {
    const userContent = localStorage.getItem(STORAGE_KEYS.userContent, 'json') || {}
    if (data) {
      userContent[this.scope] = {
        ...userContent[this.scope],
        [key]: {
          content: data,
          updatedAt: new Date().getTime()
        }
      }
    } else {
      delete userContent[this.scope]?.[key]
    }
    localStorage.setItem(STORAGE_KEYS.userContent, userContent)
  }, 500)

  clearSavedContent = key => {
    this.saveContent(key, '')
  }
}

export const commentStorageManager = new AutoSaveManager('comments')
export const checkinCommentStorageManager = new AutoSaveManager('checkin_comments')
